import { X, SlidersHorizontal } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

export const EMPTY_FILTERS = { branding: "", sent: "", state: "", city: "" };

const slug = (v) => v.toLowerCase().replace(/[^a-z0-9]+/g, "-");

const FilterSelect = ({ allLabel, value, onChange, options, testId }) => (
  <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
    <SelectTrigger data-testid={testId}
      className={`h-10 rounded-xl text-sm font-medium transition-colors ${value ? "border-[#1B2A4A] bg-[#1B2A4A] text-white" : "border-[#C9D4E6] bg-white text-[#1B2A4A]"}`}>
      <SelectValue />
    </SelectTrigger>
    <SelectContent className="max-h-72">
      <SelectItem value="all" data-testid={`${testId}-option-all`}>{allLabel}</SelectItem>
      {options.map(([v, label]) => (
        <SelectItem key={v} value={v} data-testid={`${testId}-option-${slug(v)}`}>{label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export const GiftFilters = ({ filters, onChange, options }) => {
  const set = (key) => (value) => {
    const next = { ...filters, [key]: value };
    if (key === "state" && value && filters.city) {
      const match = (options?.cities || []).some((c) => c.city === filters.city && c.state === value);
      if (!match) next.city = "";
    }
    onChange(next);
  };
  const cities = (options?.cities || []).filter((c) => !filters.state || c.state === filters.state);
  const withSelected = (list, value) => (value && !list.includes(value) ? [value, ...list] : list);
  const stateNames = withSelected(options?.states || [], filters.state);
  const cityNames = withSelected([...new Set(cities.map((c) => c.city))], filters.city);
  const active = Object.values(filters).some(Boolean);
  return (
    <div className="mb-4 rounded-2xl border border-[#C9D4E6] bg-white/60 p-3" data-testid="gift-filters">
      <div className="mb-2 flex items-center justify-between">
        <span className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wide text-[#3A4557]"><SlidersHorizontal className="h-3.5 w-3.5" /> Filter clients</span>
        {active && (
          <button onClick={() => onChange(EMPTY_FILTERS)} data-testid="gift-filters-clear-btn" className="flex items-center gap-1 text-xs font-semibold text-[#A87608] hover:text-[#7A5606] transition-colors">
            <X className="h-3.5 w-3.5" /> Clear filters
          </button>
        )}
      </div>
      <div className="grid grid-cols-2 gap-2 md:grid-cols-4">
        <FilterSelect allLabel="All branding" value={filters.branding} onChange={set("branding")} testId="gift-filter-branding"
          options={[["both", "Kavach Box + Shree Finserv"], ["shree_finserv", "Shree Finserv only"], ["none", "Branding not chosen"]]} />
        <FilterSelect allLabel="Sent and not sent" value={filters.sent} onChange={set("sent")} testId="gift-filter-sent"
          options={[["sent", "Sent"], ["not_sent", "Not sent yet"]]} />
        <FilterSelect allLabel="All states" value={filters.state} onChange={set("state")} testId="gift-filter-state"
          options={stateNames.map((s) => [s, s])} />
        <FilterSelect allLabel="All cities" value={filters.city} onChange={set("city")} testId="gift-filter-city"
          options={cityNames.map((c) => [c, c])} />
      </div>
    </div>
  );
};
